"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandProvider = void 0;
const types_1 = require("../types");
const brands_1 = require("../utils/helpers/brands");
const config_1 = require("../utils/helpers/config");
const envToBusinessUnit_1 = require("../utils/helpers/envToBusinessUnit");
class BrandProvider {
    static getBrand() {
        const brandEnv = config_1.envConfig.currentBrand;
        if (!brandEnv) {
            throw new Error(`Invalid value for brand: ${brandEnv}`);
        }
        if (Object.values(brands_1.CurrentBrandEnv).every((brand) => brand !== brandEnv)) {
            throw new Error(`Invalid value for brand: ${brandEnv}`);
        }
        const brand = envToBusinessUnit_1.envToBusinessUnit[brandEnv];
        return brand;
    }
    static isBoticario() {
        return this.getBrand() === types_1.BusinessUnit.BOT;
    }
    static isEudora() {
        return this.getBrand() === types_1.BusinessUnit.EUD;
    }
    static isOui() {
        return this.getBrand() === types_1.BusinessUnit.OUI;
    }
    static isEam() {
        return this.getBrand() === types_1.BusinessUnit.EAM;
    }
    static isMultibrand() {
        return this.getBrand() === types_1.BusinessUnit.MLT;
    }
    static getBrandDomain() {
        return brands_1.businessUnitToDomain[this.getBrand()];
    }
    static getBusinessUnitFromOrganizationSlug(organizationSlug) {
        const normalizedSlug = organizationSlug.trim().toUpperCase();
        const productBusinessUnit = new Map(Object.entries(types_1.OrganizationSlugToBusinessUnit)).get(normalizedSlug === types_1.OrganizationName.EU_AMO_MAKE
            ? types_1.OrganizationName.QUEM_DISSE_BERENICE
            : normalizedSlug);
        return productBusinessUnit || null;
    }
    static getBusinessUnitFromOrganizationName(organizationName) {
        const normalizedName = organizationName.trim().toUpperCase();
        const productBusinessUnit = new Map(Object.entries(types_1.OrganizationNameToBusinessUnit)).get(normalizedName);
        return productBusinessUnit || null;
    }
    static isSameBrandAsStore(currentBrand) {
        const productBusinessUnit = envToBusinessUnit_1.envToBusinessUnit[currentBrand];
        return this.getBrand() === productBusinessUnit;
    }
    static isSameBusinessUnitAsStore(businessUnit) {
        return this.getBrand() === businessUnit;
    }
    static getDomainBrandFromBusinessUnit(businessUnit) {
        const domainBrand = brands_1.businessUnitToDomain[businessUnit];
        if (!domainBrand) {
            return null;
        }
        return domainBrand;
    }
    static isSameOrganizationAsStore(organizationSlug) {
        const productBusinessUnit = this.getBusinessUnitFromOrganizationSlug(organizationSlug);
        return this.getBrand() === productBusinessUnit;
    }
    static getBrandSlugFromBusinessUnit(businessUnit) {
        const brandSlug = new Map(Object.entries(types_1.BusinessUnitToBrandSlug)).get(businessUnit);
        return brandSlug || null;
    }
    static getBrandForDynamicContent() {
        const brand = this.getBrand();
        switch (brand) {
            case types_1.BusinessUnit.BOT:
                return 'BOT';
            case types_1.BusinessUnit.EUD:
                return 'EUD';
            case types_1.BusinessUnit.OUI:
                return 'OUI';
            case types_1.BusinessUnit.EAM:
                return 'QDB';
            default:
                throw new Error(`Unsupported brand: ${brand}`);
        }
    }
}
exports.BrandProvider = BrandProvider;
